import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { LicenceModalComponent } from '../access-data/components/licence-modal/licence-modal.component';

@Component({
  selector: 'app-frequently-asked-questions',
  templateUrl: './frequently-asked-questions.component.html',
  styleUrls: ['./frequently-asked-questions.component.scss'],
})
export class FrequentlyAskedQuestionsComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  openLicenseTermsModal(): void {
    this.modalService.openModal(LicenceModalComponent);
  }
}
